import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { EHealthService } from 'src/app/services/e-health.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AngularFileUploaderComponent } from 'src/app/angular-file-uploader/angular-file-uploader.component';

declare var gUserId: number;

@Component({
  selector: 'app-e-health-dialog',
  templateUrl: './e-health-dialog.component.html',
  styleUrls: ['./e-health-dialog.component.scss']
})
export class EHealthDialogComponent implements OnInit {

  certificatepass: string;
  certificatealtpass: string;
  afuConfig = {};
  userid: number;

  cryptedcertificate = '';
  cryptedpassword = '';
  certificatetype = '';
  cryptedcertificatealt = '';
  cryptedpasswordalt = '';
  certificatetypealt = '';

  alternatecertificate = false;

  @ViewChild('certUpload')
    private certUpload: AngularFileUploaderComponent;
  @ViewChild('certAltUpload')
    private certAltUpload: AngularFileUploaderComponent;

  constructor(public dialogRef: MatDialogRef <EHealthDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public http: HttpClient,
              public ehealth: EHealthService) {
    this.userid = -1;
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    this.afuConfig = {
            multiple: false,
            formatsAllowed: '.p12,.acc-p12',
            uploadAPI:  {
              url: '/api/v1/ehealth/user/' + this.userid + '/certificate/process'
            },
            theme: 'attachPin',
            attachPinText: 'Sélectionner votre certificate .p12',
            hideProgressBar: true,
            hideResetBtn: true,
            hideSelectBtn: true
        };
  }

  ngOnInit(): void {
  }

  certificateUpload(event) {
      if (event.status === 200) {
        const response = event.body;
        if (response.success === true) {
            const uploadedFile = this.certUpload.allowedFiles[0].name;
            if (uploadedFile.indexOf('=') !== -1) {
                this.certificatetype = uploadedFile.split('=')[0];
            }
            // Store data in browser
            this.cryptedcertificate = response.data;
        }
    }
  }
  certificateAltUpload(event) {
    if (event.status === 200) {
        const response = event.body;
        if (response.success === true) {
            const uploadedFile = this.certAltUpload.allowedFiles[0].name;
            if (uploadedFile.indexOf('=') !== -1) {
                this.certificatetypealt = uploadedFile.split('=')[0];
            }
            // Store data in browser
            this.cryptedcertificatealt = response.data;
        }
    }
  }
  cleanCertificate() {
      this.cryptedcertificate = '';
      this.cryptedpassword = '';
      this.certificatetype = '';
      this.cryptedcertificatealt = '';
      this.cryptedpasswordalt = '';
      this.certificatetypealt = '';
      this.ehealth.cleanData();
      this.ehealth.checkCertificate();
  }
  saveData() {
      if (this.certificatepass.length === 0 || this.cryptedcertificate.length === 0) {
          console.log('Unable to save');
          return;
      }
      this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/password/process', {
          password: this.certificatepass
      })
      .subscribe(result => {
          this.ehealth.setCertificate(this.cryptedcertificate);
          this.ehealth.setPassword(result.data);
          this.ehealth.setCertificateType(this.certificatetype);
          if (!this.certificatealtpass || this.certificatealtpass.length === 0) {
            this.dialogRef.close();
          }
      });
      if (this.certificatealtpass && this.certificatealtpass.length !== 0) {
          this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/password/process', {
              password: this.certificatealtpass
          })
          .subscribe(result => {
              this.ehealth.setAltCertificate(this.cryptedcertificatealt);
              this.ehealth.setAltPassword(result.data);
              this.ehealth.setAltCertificateType(this.certificatetypealt);
              this.dialogRef.close();
          });
      }
  }
}
